$(document).ready(function(){

  $(".footer-block__link_list").wrapAll( "<div class='footer_link_list_row' />");
  $(".product-form__quantity, .buy-buttons--wrapper").wrapAll( "<div class='quantity_selector_row' />");


  // Product Tabify slider js
  var $tabi_slider = $(".product-tab-details");
  $tabi_slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite:true,
    autoplay: true,
    dots: true,
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M-5.95123e-08 5.0094C-5.66318e-08 5.25095 0.0894775 5.48317 0.288319 5.66896L0.278266 5.65017L4.6429 9.72829C5.03062 10.0906 5.65695 10.0906 6.04471 9.72829C6.43246 9.36601 6.43246 8.7808 6.04471 8.4185L3.37032 5.91967L11.0058 5.91967C11.5526 5.91967 12 5.50166 12 4.99073C12 4.4798 11.5526 4.06179 11.0058 4.06179L3.40022 4.06179L6.05476 1.58151C6.44252 1.21924 6.44248 0.634026 6.05476 0.271726C5.66704 -0.0905751 5.04071 -0.0905751 4.65295 0.271726L0.288319 4.34984C0.0994195 4.53563 -6.23928e-08 4.76785 -5.95123e-08 5.0094Z" fill="white"/></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M12 5.0094C12 5.25095 11.9105 5.48317 11.7117 5.66896L11.7217 5.65017L7.3571 9.72829C6.96938 10.0906 6.34305 10.0906 5.95529 9.72829C5.56754 9.36601 5.56754 8.7808 5.95529 8.4185L8.62968 5.91967L0.994203 5.91967C0.447376 5.91967 5.36421e-08 5.50166 5.97349e-08 4.99073C6.58277e-08 4.4798 0.447376 4.06179 0.994203 4.06179L8.59978 4.06179L5.94524 1.58151C5.55748 1.21924 5.55752 0.634027 5.94524 0.271726C6.33296 -0.0905751 6.95929 -0.0905751 7.34705 0.271726L11.7117 4.34984C11.9006 4.53563 12 4.76785 12 5.0094Z" fill="white"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding:'125px',
          arrows: false
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding:'100px',
          arrows: false
        }
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding:'70px',
          arrows: false
        }
      }
    ]
  });
  
  // product tabify js
  $('.product-title-wrapper .product-title-tab').click(function(){
    var tab_id = $(this).attr('data-tab');
    console.log(tab_id, "tab_id");
    $('.product-title-wrapper .product-title-tab').removeClass('active');
    $('.collection-product-wrapper').find('.product-tab-details').removeClass('active');
    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
    $tabi_slider.slick('refresh');
  });
  

  // logo.js
  $('.logo_flex').slick({
      speed: 8000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 5,
      slidesToScroll: 1,
      variableWidth: true,
      // adaptiveHeight: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false
    });

  // banner-js
   $('.hero_banner_slider_sec').slick({
      dots: false,
      arrows:false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M-5.95123e-08 5.0094C-5.66318e-08 5.25095 0.0894775 5.48317 0.288319 5.66896L0.278266 5.65017L4.6429 9.72829C5.03062 10.0906 5.65695 10.0906 6.04471 9.72829C6.43246 9.36601 6.43246 8.7808 6.04471 8.4185L3.37032 5.91967L11.0058 5.91967C11.5526 5.91967 12 5.50166 12 4.99073C12 4.4798 11.5526 4.06179 11.0058 4.06179L3.40022 4.06179L6.05476 1.58151C6.44252 1.21924 6.44248 0.634026 6.05476 0.271726C5.66704 -0.0905751 5.04071 -0.0905751 4.65295 0.271726L0.288319 4.34984C0.0994195 4.53563 -6.23928e-08 4.76785 -5.95123e-08 5.0094Z" fill="white"/></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M12 5.0094C12 5.25095 11.9105 5.48317 11.7117 5.66896L11.7217 5.65017L7.3571 9.72829C6.96938 10.0906 6.34305 10.0906 5.95529 9.72829C5.56754 9.36601 5.56754 8.7808 5.95529 8.4185L8.62968 5.91967L0.994203 5.91967C0.447376 5.91967 5.36421e-08 5.50166 5.97349e-08 4.99073C6.58277e-08 4.4798 0.447376 4.06179 0.994203 4.06179L8.59978 4.06179L5.94524 1.58151C5.55748 1.21924 5.55752 0.634027 5.94524 0.271726C6.33296 -0.0905751 6.95929 -0.0905751 7.34705 0.271726L11.7117 4.34984C11.9006 4.53563 12 4.76785 12 5.0094Z" fill="white"/></svg></button>',
      responsive: [
        {
          breakpoint: 391,
          settings: {
            dots: false,
            arrows:false
          }
        }
      ]
    });



  document.addEventListener("DOMContentLoaded", function() {
    var inputFields = document.querySelectorAll(" .search__input"); // Select input fields
    var divElement = document.querySelector(".empty_search_block"); // Select the div element

    // Loop through all input fields
    inputFields.forEach(function(inputField) {
        inputField.addEventListener("input", function(event) {
            var inputLetter = event.target.value.trim().charAt(0); // Extract the first letter

            console.log("Input letter:", inputLetter);

            // Add or remove class based on input letter
            if (inputLetter) {
                divElement.classList.add("show_search"); // Add class if input is not empty
                console.log("Class 'show_search' added to div element.");
            } else {
                divElement.classList.remove("show_search"); // Remove class if input is empty
                console.log("Class 'show_search' removed from div element.");
            }
        });
    });
});


  $('.search-modal__form').on('click', function(event) {
                event.stopPropagation(); // Prevent the click event from propagating to the body
                $('.empty_search_block').addClass('active_input_search');
                $('body').addClass('search_overlay');
                $('.header__inline-menu').addClass('navigation_overlay');
            });

            // Remove classes when clicking outside the specified elements
            $(document).on('click', function(event) {
                if (!$(event.target).closest('.search-modal__form, .empty_search_block, .header__inline-menu').length) {
                    $('.empty_search_block').removeClass('active_input_search');
                    $('body').removeClass('search_overlay');
                    $('.header__inline-menu').removeClass('navigation_overlay');
                }
            });

  $('.search-modal__form .search__input').on('input', function() {
    if ($(this).val().length === 1) {
      $('.empty_search_block').removeClass('active_input_search');
    } else {
      $('.empty_search_block').addClass('active_input_search');
    }
  });


   $('.search-modal__form .search__input').on('input', function() {
      if ($(this).val().length === 0) {
          $('.empty_search_block').removeClass('highlight ');
      } else {
          $('.empty_search_block').addClass('highlight ');
      }
    });

  // $(".search-modal__form .search__input").blur(function(){
  //   $('.empty_search_block').removeClass('active_input_search');
  //   $('.empty_search_block').removeClass('highlight ');
  // });

  // $(document).click(function(e) {
  //   var $container = $(".empty_search_block");
  
  //   // Check if the click is outside the container
  //   if (!$container.is(e.target) && $container.has(e.target).length === 0) {
  //     $container.removeClass('active_input_search highlight');
  //     console.log("Click outside");
  //   } else {
  //     console.log("Click inside");
  //   }
  // });



  // product tabify js
  // $('.product-accodiean--blocks .main__title--wrapper').click(function(){
  //   $('.product--accordian-content').removeClass('active');
  //   $('.product-accodiean--blocks .main__title--wrapper svg').removeClass('active');
  //   $(this).parent().find('.product--accordian-content').addClass('active');
  //   $(this).find('svg').addClass('active');
  // });

  // footer section accrodian js
  if ($(window).width() < 767) {
    $('.product--accordian-content').hide();
    $('.product-accodiean--blocks .main__title--wrapper svg').removeClass('active');
    $('.product-accodiean--blocks .main__title--wrapper').on('click', function() {
      var content = $(this).next('.product--accordian-content');
      var svgIcon = $(this).find('svg');
      content.slideToggle();
      svgIcon.toggleClass('active');
      $('.product-accodiean--blocks .main__title--wrapper').not(this).each(function() {
        $(this).next('.product--accordian-content').slideUp();
        $(this).find('svg').removeClass('active');
      });
    });
  }

// $('.collection_metafield_list').slick({
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 3

// });

 if ($(window).width() < 576) {
     $('.collection_metafield_list').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});
}

  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    // console.log(items)
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  
  });
  
});